export function InputLoadingSpinner({ active }: { active: boolean }) {
  return active ? (
    <div className="autocomplete-spinner-container">
      <i className="autocomplete-spinner" />
    </div>
  ) : (
    <></>
  );
}
